// Local translations
export const T = {
  en_GB: {
    edit: "Edit",
    // Table headers
    name: "Name",
    description: "Description",
    active: "Active",
    actions: "Actions",
    // Actions
    configure: "Configure",
    duplicate: "Duplicate",
    // Messages
    noModels: "No risk models yet. Create your first one to get started.",
    // Alerts
    error: "Error",
    inUseTitle: "Risk model in use",
    failedToDelete: "Failed to delete risk model",
    failedToToggle: "Failed to toggle status",
    // Confirm dialog
    deleteTitle: "Delete Risk Model",
    deleteDescription:
      "Are you sure you want to delete this risk model? This action cannot be undone.",
    delete: "Delete",
    cancel: "Cancel",
  },
  nb_NO: {
    edit: "Rediger",
    // Table headers
    name: "Navn",
    description: "Beskrivelse",
    active: "Aktiv",
    actions: "Handlinger",
    // Actions
    configure: "Konfigurer",
    duplicate: "Dupliser",
    // Messages
    noModels: "Ingen risikomodeller ennå. Opprett din første for å komme i gang.",
    // Alerts
    error: "Feil",
    inUseTitle: "Risikomodellen er i bruk",
    failedToDelete: "Kunne ikke slette risikomodell",
    failedToToggle: "Kunne ikke endre status",
    // Confirm dialog
    deleteTitle: "Slett risikomodell",
    deleteDescription:
      "Er du sikker på at du vil slette denne risikomodellen? Denne handlingen kan ikke angres.",
    delete: "Slett",
    cancel: "Avbryt",
  },
} as const;
